function convertLocalDateStringToISO(date: string) {
    return date?.split(' ')[0].split('/').reverse().join('-');
}

export default convertLocalDateStringToISO;
